import {Row, Col} from 'antd';
import React, {useState} from 'react';

import Loader from '../../../../components/Loader/Loader';
import MapComp from '../../../../components/MapComponents/MapComp';

import UpStreamMapData from './SupplierMapData';

const SupplierMapView: React.FC<{
  data: any[];
  setEditData: React.Dispatch<any>;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  handleDelete: (_id: string[] | string) => void;
  setShowModel: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
  type: string;
  noEdit?: boolean;
}> = ({
  data,
  handleDelete,
  setEditData,
  setIsEdit,
  setShowModel,
  type,
  isLoading
}) => {
  const mapRef: any[] = [];
  const [selectedFacility, setSelectedFacility] = useState<string | undefined>(
    undefined
  );

  return isLoading ? (
    <Loader />
  ) : (
    <div className="SupplierMapMainFlex">
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <UpStreamMapData
            data={data}
            mapRef={mapRef}
            handleDelete={handleDelete}
            setEditData={setEditData}
            setIsEdit={setIsEdit}
            setShowModel={setShowModel}
            type={type}
            selectedFacility={selectedFacility}
            setSelectedFacility={setSelectedFacility}
          />
        </Col>
        <Col span={18}>
          <MapComp
            type={type}
            mapData={data}
            markerRef={mapRef}
            center={data?.[0]?.coordinates ?? undefined}
            setSelectedFacility={setSelectedFacility}
          />
        </Col>
      </Row>
    </div>
  );
};

export default SupplierMapView;
